import { useLingui } from '@lingui/react/macro'

/** The sandbox client's notice, over its settings; its own module so the page's pending shell draws it too. */
export function SandboxNotice() {
  const { t } = useLingui()
  return (
    <div className="bg-muted/40 flex flex-col gap-1 rounded-2xl border p-5 text-sm">
      <p className="flex items-center gap-2 font-semibold">
        <span className="size-1.5 rounded-full bg-amber-500/80" />
        {t`This is your sandbox client`}
      </p>
      <p className="text-muted-foreground">
        {t`The API guide (Integrations › Guide) runs on it. Its key only creates the tutorial's sample company and candidates, its data is left out of market statistics and lists, and Reset playground deletes it. Configure it like any client: embeds follow these settings.`}
      </p>
    </div>
  )
}
